import type { ReactNode } from 'react';
import styles from './Stepper.module.css';

export type StepperStep = {
  id: string;
  label: string;
};

/**
 * The progress rail shared by every multi-step flow. It reports position only
 * — the flow itself owns navigation — so a step is never a control the user
 * can click into out of order.
 */
export function Stepper({
  steps,
  currentIndex,
  label = 'Progress',
}: {
  steps: readonly StepperStep[];
  currentIndex: number;
  /** Names the rail for screen readers when a page has more than one. */
  label?: string;
}): ReactNode {
  return (
    <ol className={styles.stepper} aria-label={label}>
      {steps.map((step, index) => (
        <li
          key={step.id}
          className={[styles.step, index < currentIndex ? styles.stepDone : '']
            .filter(Boolean)
            .join(' ')}
          aria-current={index === currentIndex ? 'step' : undefined}
        >
          <span className={styles.stepNumber} aria-hidden="true">
            {index < currentIndex ? '✓' : index + 1}
          </span>
          <span>{step.label}</span>
          {index < currentIndex ? (
            <span className="visually-hidden"> (done)</span>
          ) : null}
        </li>
      ))}
    </ol>
  );
}
